require('./bootstrap');

// Import modules...
import Vue from 'vue';
import { App as InertiaApp, plugin as InertiaPlugin } from '@inertiajs/inertia-vue';
import PortalVue from 'portal-vue';

import VueGoodTablePlugin from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import EasySlider from 'vue-easy-slider';
import VueI18n from 'vue-i18n';
// import EN from './lang/en.json';
import IT from './lang/it.json';

Vue.mixin({ methods: { route } });
Vue.use(InertiaPlugin);
Vue.use(PortalVue);
Vue.use(require('vue-moment'));
Vue.use(EasySlider);
Vue.use(VueGoodTablePlugin);
Vue.use(VueI18n);
Vue.use(require('vue-cookies'));

const app = document.getElementById('app');

// Set language code on localStorage and default to Italian ('it')
// Set language code on local storage or default to 'it' (Italian)
let langCode = localStorage.getItem('locale');
if (!langCode) {
    langCode = 'it'; // Default to Italian
    localStorage.setItem('locale', 'it');
}
const i18n = new VueI18n({
    locale: langCode, // Use the stored locale or default to Italian
    fallbackLocale: 'it', // Fallback to Italian if translation is missing
    messages: {
        // en: EN,
        it: IT
    }
});

new Vue({
    render: (h) =>
        h(InertiaApp, {
            props: {
                initialPage: JSON.parse(app.dataset.page),
                resolveComponent: (name) => require(`./Pages/${name}`).default,
            },
        }),
    i18n,
}).$mount(app);
